import React from 'react';

export interface SummaryStatCardProps {
  icon?: string;
  iconSrc?: string;
  iconColorClass?: string;
  label: string;
  value: React.ReactNode;
  badge?: React.ReactNode;
}

const SummaryStatCard: React.FC<SummaryStatCardProps> = ({
  icon,
  iconSrc,
  iconColorClass,
  label,
  value,
  badge,
}) => (
  <div className="col-md-4 mb-3 mb-md-0">
    <div className="card h-100 border summary-stat-card">
      <div className="card-body py-3">
        {iconSrc ? (
          <>
            <div className="summary-stat-svg-head d-flex align-items-center flex-nowrap mb-2">
              <img
                src={iconSrc}
                alt=""
                aria-hidden
                className="summary-stat-icon-img summary-stat-icon-img--svg"
              />
              <div className="text-muted mb-0 summary-stat-label">{label}</div>
            </div>
            <div className="h5 mb-0 font-weight-bold text-break text-dark">{value}</div>
            {badge}
          </>
        ) : (
          <div className="d-flex align-items-start">
            <span className={`material-icons mr-2 summary-stat-icon ${iconColorClass ?? ''}`}>
              {icon}
            </span>
            <div className="flex-grow-1 min-w-0">
              <div className="text-muted mb-1 summary-stat-label">{label}</div>
              <div className="h5 mb-0 font-weight-bold text-break text-dark">{value}</div>
              {badge}
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default SummaryStatCard;
